import { render } from "./TermsSectionSkeleton.vue?vue&type=template&id=59e64e38&scoped=true"
const script = {}

import "./TermsSectionSkeleton.vue?vue&type=style&index=0&id=59e64e38&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59e64e38"]])

export default __exports__